import React from "react";
import "./SignUp.scss";
import {
  isValidEmail,
  isValidMobileNumberCheck,
} from "../../UserManagement/AddNewUserModal/AddNewUserModal";
import { withRouter } from "react-router";
import { apolloClient } from "../../..";
import { gql } from "@apollo/client";
import { notify } from "../../Notify/Notify";

export default withRouter(
  class SignUp extends React.Component {
    state = {
      email: "",
      fullName: "",
      mobileNumber: "",
      organizationName: "",
      isSignupSuccessful: false,
    };

    hasValidValues = () => {
      return (
        this.state.email.trim().length > 0 &&
        isValidEmail(this.state.email.trim()) &&
        this.state.fullName.trim().length > 0 &&
        this.state.mobileNumber.trim().length > 0 &&
        isValidMobileNumberCheck(this.state.mobileNumber.trim()) > 0 &&
        this.state.organizationName.trim().length > 0
      );
    };

    loginHandler = () => {
      this.props.history.push("/login");
    };

    signUpHandler = (e) => {
      e.preventDefault();
      const { email, fullName, mobileNumber, organizationName } = this.state;
      const variables = {
        email: email,
        fullName: fullName,
        mobileNumber: mobileNumber,
        organizationName: organizationName,
      };
      apolloClient
        .mutate({
          mutation: gql`
            mutation CreateCustomer(
              $email: String!
              $fullName: String!
              $mobileNumber: String!
              $organizationName: String!
            ) {
              createCustomer(
                email: $email
                fullName: $fullName
                mobileNumber: $mobileNumber
                organizationName: $organizationName
              ) {
                success
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          const detail = "Success";
          const title = "Sign up request sent successfully!";
          const type = "success";
          notify(detail, title, type);
          this.setState({ isSignupSuccessful: true });
        })
        .catch((e) => {
          const detail = "Error";
          const title = e.message;
          const type = "error";
          notify(detail, title, type);
        });
    };

    alphaOnly = (e) => {
      let value = e.target.value;
      value = value.replace(/[^A-Za-z ]/gi, "");
      value !== this.state[e.target.name] &&
        this.setState({ [e.target.name]: value });
    };

    render() {
      return (
        <div className="sign-up-container">
          {this.state.isSignupSuccessful ? (
            <>
              <h3 className="title">Thank you for reaching out!</h3>
              <p className="sign-up-note">
                A member of our team will reach out shortly with more
                information.
                <br />
                <br />
                Hang tight and check your email!
              </p>
            </>
          ) : (
            <>
              <h3 className="title">Sign Up</h3>

              <form>
                <div className="form-groups">
                  <div className="form-group">
                    <label>Email Address*</label>
                    <input
                      type="email"
                      name="email"
                      maxLength="50"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      className={`form-control ${
                        this.state.email && !isValidEmail(this.state.email)
                          ? "error-input"
                          : ""
                      }`}
                    />
                    {this.state.email && !isValidEmail(this.state.email) ? (
                      <label className="error">
                        Please enter a valid email address eg: xyz@xyz.com
                      </label>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label>Full Name*</label>
                    <input
                      type="text"
                      name="fullName"
                      maxLength="50"
                      pattern="[a-zA-Z]*"
                      value={this.state.fullName}
                      className="form-control"
                      onChange={this.alphaOnly}
                    />
                  </div>

                  <div className="form-group">
                    <label>Mobile Number*</label>
                    <input
                      type="text"
                      name="mobileNumber"
                      maxLength="10"
                      value={this.state.mobileNumber}
                      className={`form-control ${
                        this.state.mobileNumber &&
                        !isValidMobileNumberCheck(this.state.mobileNumber)
                          ? "error-input"
                          : ""
                      }`}
                      onChange={(e) => {
                        let value = e.target.value;
                        value = value.replace(/[^0-9]+/g, "");
                        value !== this.state.mobileNumber &&
                          this.setState({ mobileNumber: e.target.value });
                      }}
                    />
                    {this.state.mobileNumber &&
                    !isValidMobileNumberCheck(this.state.mobileNumber) ? (
                      <label className="error">
                        Please enter a valid 10 digit mobile number.
                      </label>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label>Organization Name*</label>
                    <input
                      type="text"
                      name="organizationName"
                      maxLength="50"
                      value={this.state.organizationName}
                      className="form-control"
                      onChange={this.alphaOnly}
                    />
                  </div>
                </div>

                <button
                  className="btn-primary sign-up-button"
                  disabled={!this.hasValidValues()}
                  type="submit"
                  onClick={this.signUpHandler}
                >
                  Sign Up
                </button>
              </form>
            </>
          )}
          <p className="login-options">
            Already have an account?{" "}
            <span className="login" onClick={this.loginHandler}>
              Login
            </span>
          </p>
        </div>
      );
    }
  }
);
